const LANGUAGES = [
  { id: 'plaintext', label: 'Plain text', aliases: ['text', 'txt'] },
  { id: 'javascript', label: 'JavaScript', aliases: ['js', 'jsx'] },
  { id: 'typescript', label: 'TypeScript', aliases: ['ts', 'tsx'] },
  { id: 'python', label: 'Python', aliases: ['py'] },
  { id: 'html', label: 'HTML', aliases: [] },
  { id: 'css', label: 'CSS', aliases: [] },
  { id: 'json', label: 'JSON', aliases: [] },
  { id: 'bash', label: 'Bash', aliases: ['shell', 'sh', 'powershell'] },
  { id: 'sql', label: 'SQL', aliases: [] },
  { id: 'markdown', label: 'Markdown', aliases: ['md'] },
  { id: 'yaml', label: 'YAML', aliases: ['yml'] },
  { id: 'java', label: 'Java', aliases: [] },
  { id: 'csharp', label: 'C#', aliases: ['cs'] },
  { id: 'cpp', label: 'C++', aliases: ['c++', 'c'] },
  { id: 'go', label: 'Go', aliases: ['golang'] },
  { id: 'rust', label: 'Rust', aliases: ['rs'] },
  { id: 'php', label: 'PHP', aliases: [] },
  { id: 'ruby', label: 'Ruby', aliases: ['rb'] },
  { id: 'swift', label: 'Swift', aliases: [] },
  { id: 'kotlin', label: 'Kotlin', aliases: ['kt'] },
];

export const matchLanguage = (query) => {
  const q = (query || '').toLowerCase().trim();
  if (!q) return null;
  return (
    LANGUAGES.find(
      (l) => l.id === q || l.label.toLowerCase() === q || l.aliases.includes(q)
    )?.id || null
  );
};

export const filterLanguages = (searchQuery) => {
  const search = (searchQuery || '').toLowerCase();
  return LANGUAGES.filter(
    (l) =>
      l.label.toLowerCase().includes(search) ||
      l.id.includes(search) ||
      l.aliases.some((a) => a.includes(search))
  );
};

export const getLanguageById = (id) =>
  LANGUAGES.find((l) => l.id === id) || LANGUAGES[0];
